module.exports = __webpack_public_path__ + "img/4.5cc09418.jpg";